/* eslint-disable arrow-body-style */
import {JsonObject, JsonProperty} from "typescript-json-serializer";

// A predicate function use to determine the kiwis query class type
export const kiwisQueryTypePredicate = (query: any) => {
    if (query.request === "getStationList") {
        return StationListQueryConfiguration;
    }
    if (query.request === "getTimeseriesList") {
        return TimeSeriesListQueryConfiguration;
    }
    if (query.request === "getTimeseriesValues") {
        return TimeSeriesValuesQueryConfiguration;
    }
    return KiwisQueryConfiguration;
};

@JsonObject()
export class KiwisQueryConfiguration {
    // internal id to identify the query
    @JsonProperty()
    declare id: string;

    // geo.js internal type to determine the query configuration type
    @JsonProperty()
    declare queryType: string;

    // database
    @JsonProperty()
    declare datasource: string;

    @JsonProperty()
    declare service: string;

    @JsonProperty()
    declare type: string;

    @JsonProperty()
    declare request: string;

    @JsonProperty()
    declare format: string;

    /**
     * Needs to be true, when POST request is used to KIWIS
     * KIWIS does not allow body content. Parameters are only allowed as URL params.
     * To enable POST and URL params, 'kvp' has to be true
     */
    @JsonProperty()
    declare kvp: boolean;

    constructor() {}
}

@JsonObject()
export class StationListQueryConfiguration extends KiwisQueryConfiguration {
    @JsonProperty()
    declare site_no: string;

    @JsonProperty()
    declare returnfields: string;

    @JsonProperty()
    declare stationgroup_id: string;

    /**
     * selects a set of custom defined site attributes
     * (md_returnfield 'ca_site' must be active, allows comma separated list)
     */
    @JsonProperty()
    declare ca_site_returnfields: string;

    /**
     * selects a set of custom defined station attributes
     * (md_returnfield 'ca_sta' must be active, allows comma separated list)
     */
    @JsonProperty()
    declare ca_sta_returnfields: string;

    /**
     * selects a set of custom defined parameter attributes
     * (md_returnfield 'ca_par' must be active, allows comma separated list)
     */
    @JsonProperty()
    declare ca_par_returnfields: string;

    /**
     * selects a set of custom defined timeseries attributes
     * (md_returnfield 'ca_ts' must be active, allows comma separated list)
     */
    @JsonProperty()
    declare ca_ts_returnfields: string;

    constructor() {
        super();
    }
}

@JsonObject()
export class TimeSeriesListQueryConfiguration extends KiwisQueryConfiguration {
    @JsonProperty()
    declare returnfields: string;

    @JsonProperty()
    declare station_id: string;

    @JsonProperty()
    declare timeseriesgroup_id: string;

    constructor() {
        super();
    }
}

@JsonObject()
export class TimeSeriesValuesQueryConfiguration extends KiwisQueryConfiguration {
    @JsonProperty()
    declare dateformat: string;

    @JsonProperty()
    declare metadata: boolean;

    @JsonProperty()
    declare ts_id: string;

    @JsonProperty()
    declare from: string;

    @JsonProperty()
    declare to: string;

    /**
     * the time zone that will be returned for all timestamps
     * any time zone string as understood by Java (e.g. GMT+5, UTC, CET) or
     * 'individual' to use individual timeseries timezones
     */
    @JsonProperty()
    declare timezone: string;

    @JsonProperty()
    declare md_returnfields: string;

    /**
     * Specify fields to return in the data array.
     * The order of the fields is respected.
     *
     * @example: "Timestamp,Value,Absolute Value" will return: "data": [["2020-02-14T15:00:00", 0.073, 523.783]]
     */
    @JsonProperty()
    declare returnfields: string;

    @JsonProperty()
    declare timeseriesgroup_id: string;

    constructor() {
        super();
    }
}
